import React from 'react';

const CrownV2Icon = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <path
        d='M4.01805 17.0303V15.1345H15.9835V17.0303H4.01805ZM4.03284 13.8845L2.96534 7.14698C2.94423 7.14698 2.92048 7.14962 2.89409 7.1549C2.8677 7.16031 2.84395 7.16302 2.82284 7.16302C2.45228 7.15302 2.13888 7.01566 1.88263 6.75094C1.62624 6.48635 1.49805 6.16885 1.49805 5.79844C1.49805 5.41927 1.63069 5.09705 1.89596 4.83177C2.16138 4.56649 2.4836 4.43385 2.86263 4.43385C3.24166 4.43385 3.56388 4.56649 3.8293 4.83177C4.09457 5.09705 4.22721 5.41927 4.22721 5.79844C4.22721 5.8858 4.2193 5.96698 4.20346 6.04198C4.18763 6.11684 4.16749 6.18566 4.14305 6.24844L6.60763 7.35052L9.12721 3.8976C8.98096 3.77649 8.86256 3.6251 8.77201 3.44344C8.68145 3.26191 8.63617 3.06635 8.63617 2.85677C8.63617 2.47774 8.76881 2.15552 9.03409 1.8901C9.29951 1.62483 9.62173 1.49219 10.0008 1.49219C10.3798 1.49219 10.702 1.62483 10.9674 1.8901C11.2327 2.15552 11.3653 2.47774 11.3653 2.85677C11.3653 3.06635 11.3201 3.26191 11.2295 3.44344C11.1389 3.6251 11.0205 3.77649 10.8743 3.8976L13.3939 7.35052L15.8585 6.24844C15.834 6.18566 15.8139 6.11684 15.798 6.04198C15.7822 5.96698 15.7743 5.8858 15.7743 5.79844C15.7743 5.41927 15.9069 5.09705 16.1722 4.83177C16.4376 4.56649 16.7599 4.43385 17.1389 4.43385C17.5179 4.43385 17.8401 4.56649 18.1055 4.83177C18.3708 5.09705 18.5035 5.41927 18.5035 5.79844C18.5035 6.16885 18.3753 6.48635 18.1189 6.75094C17.8626 7.01566 17.5492 7.15302 17.1787 7.16302C17.1576 7.16302 17.1338 7.16031 17.1074 7.1549C17.081 7.14962 17.0573 7.14698 17.0362 7.14698L15.9687 13.8845H4.03284Z'
        fill='url(#paint0_linear_17825_47132)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_17825_47132'
          x1='10.0008'
          y1='1.49219'
          x2='10.0008'
          y2='17.0303'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D3A984' />
          <stop offset={1} stopColor='#6D5744' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CrownV2Icon;
